function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { FloatingPortal } from '@floating-ui/react';
import { useTour } from '@reactour/tour';
import React, { useMemo, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { GET_STARTED_TOURS, TOURS } from '.';
import { IconButton } from '../../../../../components/button';
import Icon from '../../../../../components/icon/Icon';
import { useRedirect } from '../../../../../hooks/useRedirect';
import { setTourSelected } from '../../../../../redux/actions/tour';
import routes from '../../../../../routes/constants';
import text from '../../../../../text';
import { isRouteIncluded } from '../../../../../utilities/routes';
export default function GetStartedButton() {
    var dispatch = useDispatch();
    var _useTour = useTour(), setSteps = _useTour.setSteps, setCurrentStep = _useTour.setCurrentStep;
    var redirect = useRedirect();
    var location = useLocation();
    var _useState = _sliced_to_array(useState(false), 2), showMenu = _useState[0], setShowMenu = _useState[1];
    var shouldShowGetStartedButton = useMemo(function() {
        return isRouteIncluded([
            routes.dashboard,
            routes.fileManager.root,
            routes.user.profile
        ])(location.pathname);
    }, [
        location.pathname
    ]);
    var toggleDropdown = function(isOpen) {
        setShowMenu(isOpen);
    };
    return shouldShowGetStartedButton && /*#__PURE__*/ React.createElement("div", {
        id: "tour-menu"
    }, /*#__PURE__*/ React.createElement(Dropdown, {
        bsPrefix: "dropdown-tour-container",
        onToggle: toggleDropdown,
        show: showMenu
    }, /*#__PURE__*/ React.createElement(Dropdown.Toggle, {
        id: "dropdown-tour-menu"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "question-circled-white"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "mr-1"
    }, text('getStarted'))), /*#__PURE__*/ React.createElement(FloatingPortal, {
        id: "tour-menu-floating-portal"
    }, /*#__PURE__*/ React.createElement(Dropdown.Menu, null, /*#__PURE__*/ React.createElement("div", {
        className: "position-absolute",
        style: {
            right: 8
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: "circled-close",
        onClick: function() {
            return toggleDropdown(false);
        }
    })), /*#__PURE__*/ React.createElement(Dropdown.Header, {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "green-1"
    }, text('Tours'))), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            dispatch(setTourSelected(TOURS.TOUR_2D_MAP));
            redirect.push(routes.mp.root);
        }
    }, text('getStarted2D')), /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            dispatch(setTourSelected(TOURS.TOUR_FILE_MANAGER));
            setSteps(GET_STARTED_TOURS[TOURS.TOUR_FILE_MANAGER]);
            setCurrentStep(0);
            if (!isRouteIncluded([
                routes.fileManager.root
            ])(location.pathname)) {
                redirect.push(routes.fileManager.root);
            }
        }
    }, text('getStartedFileManager')), /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            dispatch(setTourSelected(TOURS.TOUR_3D_VIEWER));
            setSteps(GET_STARTED_TOURS[TOURS.TOUR_3D_VIEWER]);
            setCurrentStep(0);
            redirect.push(routes.view3DExternal.root, {
                preserveQueryParams: true,
                queryParams: {
                    tour: true
                }
            });
        }
    }, text('getStarted3D')), /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Dropdown.Header, {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "green-1"
    }, text('help'))), /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            window.open('https://help.pointerra.io/articles/40420-the-viewer-interface', '_blank');
        }
    }, text('getStartedPointerraHelp'))))));
}
